










































































































































































































import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import OrderingInterface from '@core/interfaces/ordering-interface';
import PaginationInterface from '@core/interfaces/pagination-interface';
import Avatar from 'vue-avatar';
import { OrganizationMember } from '@contacts/interfaces/organization-member';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { setProp } from '@shared/helpers/operators';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { ContactRelation } from '@contacts/interfaces/contact-relation';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import ContactForm from '@contacts/components/forms/contact-form/contact-form.vue';

@Component({
  name: 'bpc-organization-relation-list-group-input',
  components: {
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-field-wrapper': FieldWrapper,
    'bpc-contact-form': ContactForm,
    'bpc-drawer-modal': DrawerModal,
    'bpc-std-form': StdForm,
    Avatar,
  },
})
export default class OrganizationRelationListGroupInput extends mixins(AbstractField) {
  declare $refs: {
    organizationRelationForm: InstanceType<typeof StdForm> & {
      saveEntity(): Promise<BPCGenericApiResponse>;
      formModel: any;
    };
    stdContactForm: InstanceType<typeof ContactForm> & {
      saveEntity(): Promise<BPCGenericApiResponse>;
    };
    deleteOrganizationRelationConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
  };
  @Prop(Array) readonly value: object[];
  @Prop(Array) declare readonly filters: any[];

  get model(): object[] {
    return this.value;
  }
  set model(val: object[]) {
    this.$emit('input', val);
  }

  async mounted() {
    this.disabledOrganizationRelationForm = this.disabled;
    await this.getOrganizationsOrMembers();
    // this.$root.$on('relationCategoryChangedFromContactRelationForm', category => {
    //   this.setEmailValuesFromCategory(category);
    // });
  }

  destroyed() {
    // this.$root.$off('relationCategoryChangedFromContactRelationForm');
  }

  entityName = 'contact-relation';
  organizationMembers: OrganizationMember[] = [];
  loading: boolean = false;
  showOrganizationRelationForm: boolean = false;
  disabledOrganizationRelationForm: boolean = false;
  isSavingOrganizationRelation: boolean = false;
  selectedOrganizationRelationId: number = null;
  showContactForm: boolean = false;
  isSavingContactForm: boolean = false;
  disabledContactForm: boolean = false;
  editableContactId: number = null;

  // Ordering and pagination are not used for the moment
  ordering: OrderingInterface = {
    order_by: '',
    order_direction: 'desc',
  };
  pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 5,
    from: 0,
    to: 0,
    total: 0,
  };

  get organizationRelationFormConfigName(): string {
    return this.origin !== 'individual'
      ? 'organization_relation_from_organization'
      : 'organization_relation_from_individual';
  }

  get saveOrganizationRelationPath(): string {
    const url = this.$bpcApiRouteHelper.getEntityPath(this.entityName);
    return this.selectedOrganizationRelationId
      ? `${url}/organizations/${this.selectedOrganizationRelationId}`
      : `${url}/organizations`;
  }

  get fetchOrganizationRelationPath(): string {
    return `${this.$bpcApiRouteHelper.getEntityPath(this.entityName)}/organizations/${
      this.selectedOrganizationRelationId
    }`;
  }

  get deleteOrganizationRelationPath(): string {
    return `${this.$bpcApiRouteHelper.getEntityPath(this.entityName)}/organizations`;
  }

  public get organizationRelationConfigFileName(): string {
    return this.tenantType === 'center' ? 'contact_relation' : 'contact_relation_for_club';
  }

  public get contactConfigFileName(): string {
    return this.tenantType === 'center' ? 'contact' : 'contact_for_club';
  }

  get organizationRelationTitleModal() {
    if (this.disabled) {
      const title = this.$t('global.models.' + this.entityName + '.name').toString();
      return title.charAt(0).toUpperCase() + title.slice(1); // capitalize
    } else if (this.selectedOrganizationRelationId) {
      return (
        this.$t('global.modals.edit') + ' ' + this.$t('global.models.' + this.entityName + '.name')
      );
    } else {
      return (
        this.$t('global.modals.create') +
        ' ' +
        this.$t('global.models.' + this.entityName + '.name')
      );
    }
  }

  get contactModalTitle(): string {
    return this.$t('global.modals.edit') + ' ' + this.$t('global.models.contact.name');
  }

  get organizationOrMemberId() {
    // Depends on the origin, the ID belongs to a family or a member
    return this.formModel?.id;
  }

  get origin() {
    // Depends on the origin, it will be 'others' or 'individual'
    return this.formModel?.type || 'individual';
  }

  get deleteOrganizationRelationModalConfig() {
    return {
      id: this.entityName + '-soft-delete-modal-' + this.generateUUIDv4(),
      title: this.$t('global.modals.soft-delete.title', {
        entityName: this.$t('global.models.' + this.entityName + '.name'),
      }),
      body: this.$t('global.modals.soft-delete.body', {
        entityName: this.$t('global.models.' + this.entityName + '.name'),
      }) as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.move_to_trash') as string,
      acceptButtonVariant: 'danger',
    };
  }

  onInputCustomEvent($event) {
    if (
      $event.eventName === 'contactRelationCategory_changed' &&
      !!$event.item &&
      !!this.$refs.organizationRelationForm?.formModel
    ) {
      // Email data
      setProp(
        this.$refs.organizationRelationForm.formModel,
        'booking_emails',
        $event.item?.booking_emails || false,
      );
      setProp(
        this.$refs.organizationRelationForm.formModel,
        'accounting_emails',
        $event.item?.accounting_emails || false,
      );
      setProp(
        this.$refs.organizationRelationForm.formModel,
        'other_emails',
        $event.item?.other_emails || false,
      );
      // Settings of the relation
      setProp(
        this.$refs.organizationRelationForm.formModel,
        'can_manage_organization',
        $event.item?.can_manage_organization || false,
      );
      setProp(
        this.$refs.organizationRelationForm.formModel,
        'forward_own_messages_with_organization',
        $event.item?.forward_own_messages_with_organization || false,
      );
      setProp(
        this.$refs.organizationRelationForm.formModel,
        'receive_organization_messages',
        $event.item?.receive_organization_messages || false,
      );
    }
  }

  onEditOrganizationRelation(relationId: number) {
    this.selectedOrganizationRelationId = relationId;
    this.showOrganizationRelationForm = true;
  }

  onEditOrganizationRelationFormButton() {
    this.disabledOrganizationRelationForm = false;
  }

  onCloseOrganizationRelationForm() {
    this.showOrganizationRelationForm = false;
    this.isSavingOrganizationRelation = false;
    this.selectedOrganizationRelationId = null;
  }

  onDeleteOrganizationRelation(relationId: number) {
    this.$refs.deleteOrganizationRelationConfirmationModal.onOpenModal(relationId);
  }

  onSuccessDeleteOrganizationRelation() {
    this.$refs.deleteOrganizationRelationConfirmationModal.onCloseModal();
    this.getOrganizationsOrMembers();
  }

  onErrorSavingOrganizationRelation() {
    this.isSavingOrganizationRelation = false;
  }

  generateUUIDv4() {
    return this.$bpcHelper.generateUUIDv4();
  }

  prepareOrganizationRelationFormToSave(familyRelation: ContactRelation) {
    if (this.origin !== 'individual') {
      setProp(familyRelation, 'organization_contact_id', this.organizationOrMemberId);
    } else {
      setProp(familyRelation, 'individual_contact_id', this.organizationOrMemberId);
    }
    return familyRelation;
  }

  onSaveOrganizationRelationForm() {
    this.isSavingOrganizationRelation = true;
    this.$refs.organizationRelationForm.saveEntity();
  }

  onOrganizationRelationFormSaved() {
    this.getOrganizationsOrMembers();
    this.onCloseOrganizationRelationForm();
  }

  async getOrganizationsOrMembers() {
    this.loading = true;
    const params = this.getQueryParams();
    const baseUrl = this.$bpcApiRouteHelper.getEntityPath('contact');

    let url: string;
    if (this.origin !== 'individual') {
      url = `${baseUrl}/organization/${this.organizationOrMemberId}/members`;
    } else {
      url = `${baseUrl}/organization/${this.organizationOrMemberId}/organizations`;
    }

    const res = await this.$bpcApi.get(`${url}`, { params: params }).toPromise();
    this.organizationMembers = res.data;
    this.loading = false;
  }

  getQueryParams() {
    return {};
  }

  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }
  onAddOrganizationRelation() {
    this.selectedOrganizationRelationId = null;
    this.showOrganizationRelationForm = true;
  }

  clickOnEditContact(member: OrganizationMember) {
    this.editableContactId = member.contact_id;
    this.showContactForm = true;
  }
  onEditContactFormButton() {
    this.disabledContactForm = false;
  }
  onCloseContactForm() {
    this.showContactForm = false;
    this.isSavingContactForm = false;
    this.editableContactId = null;
  }
  onSaveContactForm() {
    this.isSavingContactForm = true;
    this.$refs.stdContactForm.saveEntity();
  }
  onContactFormSaved() {
    this.getOrganizationsOrMembers();
    this.onCloseContactForm();
  }
  onContactSavingEntity(event) {
    this.isSavingContactForm = event;
  }
}
